export default {
  "defaultNamed": "Default ({{name}})",
  "default": "Default",
  "defaultSilent": "Default (silent)",
  "defaultNotify": "Default (notify)",
  "thresholdUsage": "{{count}} of {{maximum}} used",
  "thresholdCap": "Maximum {{maximum}} custom thresholds reached. Remove one to add another.",
  "thresholdSummary": "Alerts at {{thresholds}} usage via your enabled channels.",
  "lastUpdated": "Last updated: {{date}}",
  "removeThreshold": "Remove threshold {{threshold}}%",
  "eventWebhook": "Discord webhook for {{event}}",
  "eventAlertStyle": "Discord alert style for {{event}}",
  "discordBotDescription": "Send alerts via Discord webhook or private DM. Your admin has enabled bot DM delivery.",
  "signalRecipient": "Signal recipient",
  "thresholdRange": "Must be between 1 and 99.",
  "thresholdPreset": "Already a preset — toggle it above.",
  "thresholdDuplicate": "Already added.",
  "discordIdInvalid": "Must be 17-20 digits.",
  "whatsappNumberInvalid": "Enter a valid number (digits, spaces, +, -, parentheses).",
  "providerUrlInvalid": "Enter a valid provider URL.",
  "previewFailed": "Failed to load preview",
  "digestDailySummary": "Digest will be sent daily at {{time}} ({{timezone}}) via your enabled channels.",
  "digestWeeklySummary": "Digest will be sent weekly on {{day}} at {{time}} ({{timezone}}) via your enabled channels.",
  "webhookUsage": "{{count}} of {{maximum}}",
  "webhookCap": "Maximum of {{maximum}} webhooks reached. Remove one to add another.",
  "webhookSetDefault": "Set {{name}} as default webhook",
  "webhookNameFor": "Name for {{name}}",
  "webhookTestFor": "Send test to {{name}}",
  "webhookRemoveFor": "Remove {{name}}",
  "webhookUrlFor": "Webhook URL for {{name}}",
  "previewEmpty": "No pending updates to include in digest.",
  "previewCount_one": "{{count}} update available:",
  "previewCount_other": "{{count}} updates available:",
  "previewCount_many": "{{count}} updates available:",
  "previewPlatform": "Platform:",
  "previewDashboard": "Dashboard: {{current}} → {{latest}}",
  "previewApplications": "Applications:",
  "webhook": "Webhook",
  "dMDelivery": "DM Delivery",
  "help": "Help",
  "directMessageFromTheBot": "Direct message from the bot",
  "privateDMsOnceYouVeLinkedYourDiscordNo": "Private DMs once you've linked your Discord. No webhook required.",
  "channelWebhook": "Channel webhook",
  "postsAlertsIntoADiscordChannelUsingYourSaved": "Posts alerts into a Discord channel using your saved webhook URL.",
  "both": "Both",
  "sendABotDMAndPostToYourWebhook": "Send a bot DM and post to your webhook channel.",
  "discordNotificationSetup": "Discord Notification Setup",
  "close": "Close",
  "discordSetupSections": "Discord setup sections",
  "addOneOrMoreNamedChannelWebhooksAlertsPost": "Add one or more named channel webhooks. Alerts post to your default webhook unless you route a specific event elsewhere in Notification Events. URLs are stored with your preferences and masked here.",
  "defaultSilentDelivery": "Default silent delivery",
  "silentNoPushNotificationsToChannelMembers": "Silent — no push notifications to channel members",
  "loudTriggersPushNotificationsForChannelMembers": "Loud — triggers push notifications for channel members",
  "theDefaultForEveryEventOverrideItPerEvent": "The default for every event. Override it per event under Notification Events.",
  "privateAlertsChannel": "Private alerts channel",
  "forAlertsOnlyYouCanSeeCreateAPrivate": "For alerts only you can see, create a private channel:",
  "createAChannelForExampleQbAlerts": "Create a channel, for example #qb-alerts.",
  "setEveryoneToDenyViewChannel": "Set @everyone to deny View Channel.",
  "addYourselfWithAllowViewChannel": "Add yourself with allow View Channel.",
  "openEditChannelIntegrationsWebhooksAndCopyTheURL": "Open Edit Channel → Integrations → Webhooks and copy the URL.",
  "webhookMessagesAreVisibleToAnyoneWhoCanSee": "Webhook messages are visible to anyone who can see the channel. Use channel permissions to control visibility.",
  "manageDiscordChannelSettings": "Manage Discord channel settings",
  "privateDMDelivery": "Private DM delivery",
  "yourAdministratorHasEnabledADiscordBotEnterYour": "Your administrator has enabled a Discord bot. Enter your User ID below to receive notifications as private DMs instead of channel webhook messages.",
  "whereAlertsArrive": "Where alerts arrive",
  "aBotDMWorksOnceYouVeLinkedYour": "A bot DM works once you've linked your Discord account — no webhook needed. A channel webhook posts into a Discord channel you control.",
  "noWebhookURLIsSavedAddOneOnThe": "No webhook URL is saved. Add one on the Webhook tab, or alerts will fall back to a bot DM.",
  "discordUserID": "Discord User ID",
  "yourDiscordUserID1720Digits": "Your Discord User ID (17-20 digits)",
  "sending": "Sending...",
  "testDM": "Test DM",
  "findingYourDiscordUserID": "Finding your Discord User ID",
  "openDiscordSettingsAdvancedAndEnableDeveloperMode": "Open Discord Settings → Advanced and enable Developer Mode.",
  "rightClickYourProfilePictureOrUsername": "Right-click your profile picture or username.",
  "clickCopyUserID": "Click Copy User ID.",
  "sharedServerRequirement": "Shared server requirement",
  "theBotMustShareAtLeastOneDiscordServer": "The bot must share at least one Discord server with you. DMs work cross-server — as long as you and the bot share any server, messages arrive in your inbox.",
  "joinOurDiscordServer": "Join our Discord server",
  "contactYourQuickBoxAdministratorForTheBotInviteLink": "Contact your QuickBox administrator for the bot invite link or server name.",
  "dMsAreCompletelyPrivateNoOneElseCanSee": "DMs are completely private. No one else can see them, and no shared channel is required.",
  "configureBotTokenAndInviteLink": "Configure bot token and invite link",
  "webhookNotWorking": "Webhook not working?",
  "makeSureTheWebhookURLStartsWithHttpsDiscord": "Make sure the webhook URL starts with https://discord.com/api/webhooks/. If the channel was deleted or the webhook was removed, create a new webhook and update the URL.",
  "botNotInYourServer": "Bot not in your server?",
  "contactYourServerAdministratorForTheBotInviteLink": "Contact your server administrator for the bot invite link. The bot must be added to at least one Discord server that you are also a member of before DMs will work.",
  "dMsNotArriving": "DMs not arriving?",
  "checkYourDiscordPrivacySettingsOpenTheSharedServer": "Check your Discord privacy settings. Open the shared server, go to Privacy Settings, and enable Allow direct messages from server members.",
  "wrongUserIDFormat": "Wrong User ID format?",
  "yourDiscordUserIDIsA1720Digit": "Your Discord User ID is a 17-20 digit number, not your username or display name. Enable Developer Mode in Discord settings, then right-click your profile to copy the correct ID.",
  "privacySecurity": "Privacy & security",
  "webhookURLsAndUserIDsAreStoredInYour": "Webhook URLs and User IDs are stored in your notification preferences. The bot only sends messages you have opted into. It cannot read your messages, access your servers, or share your data with other users.",
  "inAppAlerts": "In-app alerts",
  "toastBannersAndNotificationBadgesInsideTheDashboard": "Toast banners and notification badges inside the dashboard.",
  "onByDefault": "On by default",
  "emailNotifications": "Email notifications",
  "sendEmailsUsingTheConfiguredSMTPServer": "Send emails using the configured SMTP server.",
  "offUntilSMTPIsConfigured": "Off until SMTP is configured",
  "realtime": "Realtime",
  "liveUpdatesForFutureWebsocketOrSSEEvents": "Live updates for future websocket or SSE events.",
  "sendAlertsViaDiscordWebhookOrPrivateDM": "Send alerts via Discord webhook or private DM.",
  "provideAWebhookURLOrDiscordUserID": "Provide a webhook URL or Discord User ID",
  "encryptedNotificationsViaSignalMessenger": "Encrypted notifications via Signal messenger.",
  "requiresAdminToEnableSignal": "Requires admin to enable Signal",
  "sendAlertsToAVerifiedWhatsAppNumber": "Send alerts to a verified WhatsApp number.",
  "requiresAProviderIntegration": "Requires a provider integration",
  "signalNumberPlaceholder": "+1234567890 (E.164 format)",
  "hideNumber": "Hide number",
  "showNumber": "Show number",
  "updatesDigest": "Updates digest",
  "consolidatePendingUpdateNotificationsIntoAScheduledSummary": "Consolidate pending update notifications into a scheduled summary.",
  "enableUpdatesDigest": "Enable updates digest",
  "whenEnabledIndividualUpdateAvailableAlertsAreReplacedBy": "When enabled, individual update-available alerts are replaced by a digest at your chosen schedule.",
  "enabled": "Enabled",
  "frequency": "Frequency",
  "dailyOrWeeklyDelivery": "Daily or weekly delivery.",
  "digestFrequency": "Digest frequency",
  "daily": "Daily",
  "weekly": "Weekly",
  "dayOfWeek": "Day of week",
  "whichDayToSendTheWeeklyDigest": "Which day to send the weekly digest.",
  "digestDayOfWeek": "Digest day of week",
  "sendDigestAt": "Send digest at",
  "deliveryTimeOfDay": "Delivery time of day.",
  "digestDeliveryHour": "Digest delivery hour",
  "digestTimezone": "Digest timezone",
  "overrideTheDashboardDefaultTimezone": "Override the dashboard default timezone.",
  "dashboardDefault": "Dashboard default",
  "loading": "Loading...",
  "previewDigest": "Preview digest",
  "digestPreview": "Digest preview",
  "closePreview": "Close preview",
  "saveAValidDiscordUserIDFirst": "Save a valid Discord User ID first",
  "couldNotSaveSettingsBeforeTesting": "Could not save settings before testing",
  "pleaseTrySavingManuallyFirst": "Please try saving manually first.",
  "testDMSent": "Test DM sent",
  "checkYourDiscordMessages": "Check your Discord messages.",
  "testFailed": "Test failed",
  "unableToSendTestDM": "Unable to send test DM.",
  "unableToReachTheServer": "Unable to reach the server.",
  "testSent": "Test sent",
  "checkYourDiscordChannel": "Check your Discord channel.",
  "unableToSendTestMessage": "Unable to send test message.",
  "defaultsRestored": "Defaults restored",
  "reviewAndSaveToKeepTheseDefaults": "Review and save to keep these defaults.",
  "notificationSettingsSaved": "Notification settings saved",
  "settingsCachedLocallyButDidNotReachTheServer": "Settings cached locally but did not reach the server. They may be lost on refresh.",
  "unableToSaveSettings": "Unable to save settings",
  "updateTimeUnknown": "Update time unknown",
  "externalNotificationChannelsAreAdminManaged": "External notification channels are admin-managed",
  "yourAdministratorHasDisabledUserManagementOfDiscordSignal": "Your administrator has disabled user management of Discord, Signal, and WhatsApp notification channels. Contact your admin to configure these channels for your account.",
  "notificationChannels": "Notification Channels",
  "chooseWhereAlertsDeliverGlobalChannelTogglesApplyUnless": "Choose where alerts deliver. Global channel toggles apply unless overridden per event.",
  "comingSoon": "Coming Soon",
  "on": "On",
  "off": "Off",
  "channelSetup": "Channel setup",
  "configurePerChannelEndpointsSavedCredentialsAreStoredWith": "Configure per-channel endpoints. Saved credentials are stored with your preferences and masked here.",
  "dM": "DM",
  "notConfigured": "Not configured",
  "configureDiscord": "Configure Discord",
  "active": "Active",
  "notEnabled": "Not enabled",
  "signalNotificationsAreNotEnabledByTheAdministrator": "Signal notifications are not enabled by the administrator.",
  "noteOptional": "Note (optional)",
  "askYourAdministratorToEnableSignalInNotificationChannel": "Ask your administrator to enable Signal in notification channel settings.",
  "whatsAppNumberEG15555555555": "WhatsApp number (e.g. +1 555 555 5555)",
  "providerWebhookURLOptional": "Provider webhook URL (optional)",
  "whatsAppDeliveryIsUnderDevelopmentAndWillBeAvailable": "WhatsApp delivery is under development and will be available in a future release.",
  "diskUsageAlerts": "Disk usage alerts",
  "setThresholdsForStorageUsageAlertsAndChooseWhen": "Set thresholds for storage usage alerts and choose when to be notified.",
  "storageUsageAlerts": "Storage usage alerts",
  "alertsTriggerWhenUsageCrossesAnySelectedThreshold": "Alerts trigger when usage crosses any selected threshold.",
  "presetThresholds": "Preset thresholds",
  "presetDiskUsageThresholds": "Preset disk usage thresholds",
  "customThresholds": "Custom thresholds",
  "addExtraAlertPoints199OutsideThePresets": "Add extra alert points (1-99%) outside the presets above. Existing values can be removed individually.",
  "customDiskUsageThresholds": "Custom disk usage thresholds",
  "eG92": "e.g. 92",
  "newCustomThreshold": "New custom threshold",
  "addThreshold": "Add threshold",
  "noThresholdsConfiguredAddAPresetOrCustomValue": "No thresholds configured — add a preset or custom value to enable alerts.",
  "notificationEvents": "Notification Events",
  "turnEventsOnOrOffAndOptionallyOverrideDelivery": "Turn events on or off and optionally override delivery channels.",
  "admin": "Admin",
  "discordRouting": "Discord routing",
  "alert": "Alert",
  "silent": "Silent",
  "notify": "Notify",
  "unsavedChanges": "Unsaved changes",
  "autoSaving": "Auto-saving...",
  "resetToDefaults": "Reset to defaults",
  "saving": "Saving...",
  "saveChanges": "Save changes",
  "aWebhookWithThisNameAlreadyExists": "A webhook with this name already exists.",
  "mustStartWithHttpsDiscordComApiWebhooks": "Must start with https://discord.com/api/webhooks/",
  "webhooks": "Webhooks",
  "noWebhooksYetAddOneBelowToPostAlerts": "No webhooks yet. Add one below to post alerts into a Discord channel.",
  "configuredDiscordWebhooks": "Configured Discord webhooks",
  "defaultWebhook": "Default webhook",
  "setAsDefault": "Set as default",
  "webhookName": "Webhook name",
  "sendingTest": "Sending test...",
  "sendTestMessage": "Send test message",
  "removeWebhook": "Remove webhook",
  "saveURL": "Save URL",
  "saveWebhookURL": "Save webhook URL",
  "cancel": "Cancel",
  "cancelURLEdit": "Cancel URL edit",
  "editURL": "Edit URL",
  "nameEGCriticalAlerts": "Name (e.g. Critical Alerts)",
  "newWebhookName": "New webhook name",
  "newWebhookURL": "New webhook URL",
  "add": "Add",
  "groupApplicationsTitle": "Applications & Services",
  "groupApplicationsDescription": "Health and lifecycle alerts for QuickBox-managed apps.",
  "eventAppOfflineTitle": "Application goes offline",
  "eventAppOfflineDescription": "An installed app stops responding or a service is down.",
  "eventAppOnlineTitle": "Application comes online",
  "eventAppOnlineDescription": "A previously offline application is back and healthy.",
  "eventSystemDegradedTitle": "Critical service degraded",
  "eventSystemDegradedDescription": "Reverse proxy, auth, or database health issues detected.",
  "eventSystemDiskUsageTitle": "Disk usage threshold reached",
  "eventSystemDiskUsageDescription": "Trigger when storage usage crosses your configured thresholds.",
  "eventAppUpdateAvailableTitle": "Application update available",
  "eventAppUpdateAvailableDescription": "A managed app has a new version ready to install.",
  "eventQbUpdateAvailableTitle": "QuickBox update available",
  "eventQbUpdateAvailableDescription": "A new version of the QuickBox CLI or platform is available.",
  "eventDashboardUpdateAvailableTitle": "Dashboard update available",
  "eventDashboardUpdateAvailableDescription": "A new version of the v4 dashboard is ready to install.",
  "eventSignalUpdateAvailableTitle": "signal-cli update available",
  "eventSignalUpdateAvailableDescription": "A new version of the signal-cli binary is available.",
  "eventAppUpdatedTitle": "Application updated successfully",
  "eventAppUpdatedDescription": "A managed app finished updating without errors.",
  "groupSecurityTitle": "Account & Security",
  "groupSecurityDescription": "Keep tabs on account changes and access attempts.",
  "eventSecurityNewLoginTitle": "New login detected",
  "eventSecurityNewLoginDescription": "Alert when a new device or IP signs in to your account.",
  "eventSecuritySessionRevokedTitle": "Session revoked",
  "eventSecuritySessionRevokedDescription": "When a session is signed out or removed from another device.",
  "eventSecurityPasswordChangedTitle": "Password changed",
  "eventSecurityPasswordChangedDescription": "Confirmations when your password is updated.",
  "eventSecurityMfaChangedTitle": "2FA / Passkey changes",
  "eventSecurityMfaChangedDescription": "When multi-factor authentication or passkeys are added or removed.",
  "groupAutomationTitle": "Jobs & Automation",
  "groupAutomationDescription": "Background tasks and scheduled jobs.",
  "eventJobCompletedTitle": "Background task completed",
  "eventJobCompletedDescription": "Long-running jobs (e.g., library scans) finished.",
  "eventJobFailedTitle": "Background task failed",
  "eventJobFailedDescription": "High-value failures that may need attention.",
  "groupSupportTitle": "Support & Collaboration",
  "groupSupportDescription": "Tickets and chat notifications (future-facing).",
  "eventSupportTicketUpdatedTitle": "Support ticket updates",
  "eventSupportTicketUpdatedDescription": "New or updated tickets assigned to you.",
  "eventSupportChatMessageTitle": "Direct message or mention",
  "eventSupportChatMessageDescription": "Mentions and new chat messages in QuickBox rooms.",
  "groupDigestTitle": "Digest & Noise Controls",
  "groupDigestDescription": "Control digests and quiet hours for calmer alerts.",
  "eventDigestDailyTitle": "Daily digest",
  "eventDigestDailyDescription": "Roll-up of key events each day.",
  "eventDigestWeeklyTitle": "Weekly digest",
  "eventDigestWeeklyDescription": "Sunday summary of your server activity.",
  "eventQuietHoursEnabledTitle": "Quiet hours",
  "eventQuietHoursEnabledDescription": "Mute non-critical alerts between your preferred hours.",
  "groupAdminFleetTitle": "Fleet Visibility",
  "groupAdminFleetDescription": "Cross-user alerts surfaced to admin users.",
  "eventAdminAppOfflineTitle": "Any user's application goes offline",
  "eventAdminAppOfflineDescription": "An installed app on any user's account stops responding.",
  "eventAdminAppOnlineTitle": "Any user's application comes online",
  "eventAdminAppOnlineDescription": "A previously offline app on any user's account is back and healthy.",
  "eventAdminVpnKillSwitchTitle": "VPN kill switch triggered",
  "eventAdminVpnKillSwitchDescription": "A user's VPN tunnel became unreachable and their app was stopped.",
  "eventAdminVpnFailbackTitle": "VPN routing failback",
  "eventAdminVpnFailbackDescription": "A user's VPN tunnel became unreachable and their app reverted to the host network.",
  "eventAdminVpnRecoveryTitle": "VPN auto-recovery result",
  "eventAdminVpnRecoveryDescription": "Outcome of an automatic VPN recovery attempt — recovered or gave up.",
  "eventAdminMonitorAlertTitle": "System Monitor rule triggered",
  "eventAdminMonitorAlertDescription": "A System Monitor rule crossed its threshold on a host-wide metric or service.",
  "eventAdminPhpFpmOfflineTitle": "Shared PHP pool offline",
  "eventAdminPhpFpmOfflineDescription": "A PHP-FPM version used by at least one installed app (rutorrent, nextcloud, phpmyadmin) is no longer running.",
  "eventAdminPhpFpmOnlineTitle": "Shared PHP pool recovered",
  "eventAdminPhpFpmOnlineDescription": "A previously-offline PHP-FPM version is running again.",
  "eventAdminSecurityAttackSpikeTitle": "Attack spike detected",
  "eventAdminSecurityAttackSpikeDescription": "Many IPs banned by fail2ban in a short window — a coordinated attack may be underway.",
  "eventNewsAnnouncementTitle": "QB News announcements",
  "eventNewsAnnouncementDescription": "A new QB News announcement is published, or an existing one is updated (System → News).",
  "groupTransfersTitle": "Transfers",
  "groupTransfersDescription": "Inter-instance transfer activity surfaced to admin users.",
  "eventAdminTransferActivityTitle": "Transfer activity",
  "eventAdminTransferActivityDescription": "Alerts when an inter-instance transfer request arrives, sends, completes, or fails.",
  "eventAdminPackageInstallRequestedTitle": "Install requested",
  "eventAdminPackageInstallRequestedDescription": "A regular account asks for the first install of a shared torrent client; choose its version and approve or deny.",
  "eventPackageInstallRequestApprovedTitle": "Install request approved",
  "eventPackageInstallRequestApprovedDescription": "An administrator approved your install request.",
  "eventPackageInstallRequestDeniedTitle": "Install request denied",
  "eventPackageInstallRequestDeniedDescription": "An administrator denied your install request."
} as const;
